import React from 'react';
import { connect } from 'react-redux';
import { NavLink, Link, withRouter } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import CreditsPill from './CreditsPill';
import MobileDrawer from './MobileDrawer';
import Searchbox from '../searchbox';
import FeedbackModal from '../FeedbackModal';
// LogoAnimation removed - using inline SVG logo
import WorkspaceHeader from '../workspaceHeader';
import AgencyPlansModal from '../AgencyPlansModal/AgencyPlansModal';
import { getWorkspacePath } from '../../utils/workspaceUtils';
import { updatePageTitle } from '../../utils/titleManager';

import { setNewDealModal } from '../../store/Deals/index';
import { setNewAgentModal } from '../../store/Agent/index';

import './topnav.css';

class TopNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      showDropdown: false,
      dropdownOpen: false,
      showAgencyPlansModal: false,
    };
    this.inputRef = React.createRef();
    this.searchBoxRef = React.createRef();
    this.dropdownInputRef = React.createRef();
    this.closeTimeout = null;
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.updateTitleForCurrentRoute();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateTitleForCurrentRoute();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
  }

  updateTitleForCurrentRoute = () => {
    const { routes, currentBranding, rtlActive } = this.props;
    const activeRoute = routes.find(r => this.activeRoute(r.path) === 'active');
    if (activeRoute && activeRoute.name) {
      updatePageTitle(rtlActive ? activeRoute.rtlName : activeRoute.name, currentBranding?.agencyName);
    } else {
      updatePageTitle('', currentBranding?.agencyName);
    }
  };

  workspacePath = (path) => getWorkspacePath(path, this.props.currentWorkspace?._id);
  activeRoute = (routeName) => this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';

  toggleMobileDrawer = () => this.setState(prev => ({ mobileOpen: !prev.mobileOpen }));
  closeMobileDrawer = () => this.setState({ mobileOpen: false });

  toggleDropDownPlus = () => this.setState(prev => ({ dropdownOpen: !prev.dropdownOpen }));
  showDropdown = () => this.setState({ showDropdown: true });

  handleBottomSearchClick = () => {
    this.setState({ showDropdown: true }, () => {
      requestAnimationFrame(() => this.dropdownInputRef.current?.focus());
    });
  };

  handleClickOutside = (e) => {
    if (!this.state.showDropdown) return;
    if (this.searchBoxRef.current && !this.searchBoxRef.current.contains(e.target)) {
      if (this.closeTimeout) clearTimeout(this.closeTimeout);
      this.closeTimeout = setTimeout(() => {
        this.setState({ showDropdown: false });
      }, 100);
    }
  };

  toggleAgencyPlansModal = () => {
    this.setState(prev => ({ showAgencyPlansModal: !prev.showAgencyPlansModal }));
  };

  render() {
    const { routes, rtlActive, isCtrlPressed, currentBranding, currentWorkspace } = this.props;
    const { mobileOpen, showDropdown, dropdownOpen, showAgencyPlansModal } = this.state;

    const visibleRoutes = routes.filter(r => !r.workspacePrefixed && !r.hidden);

    return (
      <>
        <nav className="topnav-bar">
          {/* Left: Logo + Nav Links */}
          <div className="topnav-left">
            <Link to={this.workspacePath('/')} className="topnav-logo">
              {currentBranding?.['isCustom'] && currentBranding?.['logo'] ? (
                <img src={currentBranding['logo']} alt={currentBranding['agencyName'] || 'Logo'} style={{ height: '36px', maxWidth: '150px', objectFit: 'contain' }} />
              ) : currentBranding?.['isCustom'] && currentBranding?.['agencyName'] ? (
                <span style={{ fontSize: '20px', fontWeight: '700', color: '#fff', letterSpacing: '-0.3px' }}>{currentBranding['agencyName']}</span>
              ) : (
                <svg width="126" height="37" viewBox="0 0 126 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="tnO1" x1="0" y1="0.5" x2="1" y2="0.5"><stop offset="0%" stopColor="#c44070" stopOpacity="0"/><stop offset="40%" stopColor="#e8709a"/><stop offset="60%" stopColor="#e8709a"/><stop offset="100%" stopColor="#c44070" stopOpacity="0"/></linearGradient>
                    <linearGradient id="tnO2" x1="0" y1="0.5" x2="1" y2="0.5"><stop offset="0%" stopColor="#ff85b0" stopOpacity="0"/><stop offset="40%" stopColor="#ffaacf"/><stop offset="60%" stopColor="#ffaacf"/><stop offset="100%" stopColor="#ff85b0" stopOpacity="0"/></linearGradient>
                    <radialGradient id="tnN" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#ffffff"/><stop offset="50%" stopColor="#ffb8d0"/><stop offset="100%" stopColor="#d4547a"/></radialGradient>
                    <filter id="tnG" x="-80%" y="-80%" width="260%" height="260%"><feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                  </defs>
                  <ellipse cx="18.5" cy="18.5" rx="14" ry="5.5" transform="rotate(-40 18.5 18.5)" fill="none" stroke="url(#tnO1)" strokeWidth="1.4"/>
                  <ellipse cx="18.5" cy="18.5" rx="14" ry="5.5" transform="rotate(40 18.5 18.5)" fill="none" stroke="url(#tnO2)" strokeWidth="1.4"/>
                  <ellipse cx="18.5" cy="18.5" rx="14" ry="5.5" transform="rotate(90 18.5 18.5)" fill="none" stroke="url(#tnO1)" strokeWidth="1" opacity="0.6"/>
                  <circle cx="4.5" cy="18.5" r="2.2" fill="#ff85b0" filter="url(#tnG)"/>
                  <circle cx="31" cy="14.5" r="1.8" fill="#e8709a" filter="url(#tnG)"/>
                  <circle cx="21" cy="5" r="1.8" fill="#c44070" filter="url(#tnG)"/>
                  <circle cx="18.5" cy="18.5" r="4" fill="#3d0f20" opacity="0.8" filter="url(#tnG)"/>
                  <circle cx="18.5" cy="18.5" r="3" fill="url(#tnN)"/>
                  <circle cx="18.5" cy="18.5" r="1.5" fill="white" opacity="0.95"/>
                  <text x="44" y="26" fontFamily="'Segoe UI', Arial, sans-serif" fontSize="18" fontWeight="600" fill="#f5e6ed" letterSpacing="0.5">Sales AI</text>
                </svg>
              )}
            </Link>

            {/* Hamburger for mobile */}
            <button
              className={`topnav-hamburger ${mobileOpen ? 'open' : ''}`}
              onClick={this.toggleMobileDrawer}
            >
              <span />
            </button>

            {/* Desktop nav links */}
            <div className="topnav-links">
              {visibleRoutes.map((route, key) => (
                <NavLink
                  key={key}
                  to={this.workspacePath(route.path)}
                  className={`topnav-link ${this.activeRoute(route.path)}`}
                  activeClassName="active"
                >
                  <span className="nav-icon">{route.icon}</span>
                  <span>{rtlActive ? route.rtlName : route.name}</span>
                  {isCtrlPressed && route.shortcut && (
                    <span className="sortcut-text">{route.shortcut}</span>
                  )}
                </NavLink>
              ))}
            </div>
          </div>

          {/* Right: Search + Add + Credits + WorkspaceHeader */}
          <div className="topnav-right">
            {/* Search */}
            <div className="topnav-search-wrapper" ref={this.searchBoxRef}>
              <span className="search-icon">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.40156 10.6464C2.74292 10.6464 0.578369 8.48183 0.578369 5.82319C0.578369 3.16455 2.74292 1 5.40156 1C8.0602 1 10.2248 3.16455 10.2248 5.82319C10.2248 8.48183 8.0602 10.6464 5.40156 10.6464ZM5.40156 1.70583C3.12878 1.70583 1.2842 3.55511 1.2842 5.82319C1.2842 8.09127 3.12878 9.94055 5.40156 9.94055C7.67434 9.94055 9.51892 8.09127 9.51892 5.82319C9.51892 3.55511 7.67434 1.70583 5.40156 1.70583Z" fill="#50525870" stroke="#50525870" strokeWidth="0.236842" />
                  <path d="M12.8959 13.7066C12.8021 13.7068 12.7083 13.6723 12.6342 13.5984L8.68189 9.63155C8.5386 9.48864 8.53829 9.2518 8.68119 9.10852C8.82409 8.96524 9.06094 8.96492 9.20422 9.10783L13.1565 13.0747C13.2998 13.2176 13.3001 13.4545 13.1572 13.5977C13.0833 13.6718 12.9896 13.7065 12.8959 13.7066Z" fill="#50525870" stroke="#50525870" strokeWidth="0.236842" />
                </svg>
              </span>
              <TextField
                fullWidth
                hiddenLabel
                size="small"
                name="search"
                variant="standard"
                inputRef={this.inputRef}
                className="topnav-search"
                placeholder="Search agents, deals..."
                onClick={this.handleBottomSearchClick}
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: 'center' } }}
              />
              <button className="right-slash" onClick={this.showDropdown} ref={this.dropdownInputRef}>/</button>
              {showDropdown && (
                <div className="search-dropdown">
                  <div className="search-dropdown-item">
                    <div className="tab-box">
                      <Searchbox ref={this.dropdownInputRef} currentWorkspace={currentWorkspace} />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="topnav-divider" />

            {/* Workspace Header (Ask Atlas, Dialpad, Settings, Admin) */}
            <WorkspaceHeader />
          </div>
        </nav>

        {/* Mobile Drawer */}
        <MobileDrawer
          isOpen={mobileOpen}
          onClose={this.closeMobileDrawer}
          routes={routes}
          rtlActive={rtlActive}
          isCtrlPressed={isCtrlPressed}
          onShowAgencyPlans={this.toggleAgencyPlansModal}
        />

        {/* Feedback Modal */}
        <FeedbackModal />

        {/* Agency Plans Modal */}
        <AgencyPlansModal isOpen={showAgencyPlansModal} toggle={this.toggleAgencyPlansModal} />
      </>
    );
  }
}

const mapDispatchToProps = { setNewDealModal, setNewAgentModal };
const mapStateToProps = ({ Settings: { currentWorkspace, currentBranding, isCtrlPressed } }) => ({
  currentWorkspace,
  currentBranding,
  isCtrlPressed,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopNavBar));
